const containerCls = "_086cvcdpsb";
const inputCls = "_086i1uqiam";
const placeholderCls = "_086p8q6tw3";
const placeholderIconCls = "_086p2eu8c9";

export { containerCls, inputCls, placeholderCls, placeholderIconCls };
import "./SimpleInput.style.linaria.module.css";
//# sourceMappingURL=SimpleInput.style.js.map
